// Copyright © 2017-2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-app>
    <v-toolbar app fixed clipped-left clipped-right class="white">
      <v-toolbar-side-icon v-if="isMobile" @click.stop="showDrawer = !showDrawer"></v-toolbar-side-icon>
      <a href="https://www.sdgsystems.com/phototag" style="text-decoration: none;"><img src="static/logotf.png" height="48"></a>
      <v-spacer></v-spacer>
      <v-btn href="https://www.sdgsystems.com/phototag" v-if="!isMobile" flat>Home</v-btn>
      <v-btn :to="{name: 'docsApi'}" v-if="!isMobile" flat>API</v-btn>
      <v-btn :to="{name: 'docsManual'}" v-if="!isMobile" flat>User Manual</v-btn>
      <v-btn :to="{name: 'registerAgreement'}" v-if="!isMobile" flat>Get Started</v-btn>
      <v-btn :to="{name: 'pricing'}" v-if="!isMobile" flat>Pricing</v-btn>
      <v-btn :to="{name: 'login'}" v-if="!isMobile" depressed dark color="primary">Login</v-btn>
    </v-toolbar>
    <v-navigation-drawer app v-if="isMobile" clipped persistent enable-resize-watcher fixed v-model="showDrawer">
      <v-list>
        <v-list-tile>
          <v-list-tile-content>
            <img v-bind:src="'static/logotf.png'" style="height: 100%; padding-top: 8px;">
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile href="https://www.sdgsystems.com/phototag">
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'registerAgreement'}">
          <v-list-tile-content>
            <v-list-tile-title>Get Started</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'login'}">
          <v-list-tile-content>
            <v-list-tile-title>Login</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'pricing'}">
          <v-list-tile-content>
            <v-list-tile-title>Pricing</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'docsApi'}">
          <v-list-tile-content>
            <v-list-tile-title>API</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'docsManual'}">
          <v-list-tile-content>
            <v-list-tile-title>User Manual</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'privacyPolicy'}">
          <v-list-tile-content>
            <v-list-tile-title>Privacy Policy</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{name: 'termsOfService'}">
          <v-list-tile-content>
            <v-list-tile-title>Terms Of Service</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content app style="padding-bottom: 16px;">
      <router-view></router-view>
    </v-content>
    <v-footer app absolute color="primary" class="" style="height: auto; position: relative;">
      <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm4 class="white--text">
          <img src="static/logotf.png" height="48" style="padding-top: 8px;">
          <p>
            <router-link  class="white--text ml-2" :to="{name: 'termsOfService'}">Terms Of Service</router-link>
          </p>
          <p>
            <router-link class="white--text ml-2" :to="{name: 'privacyPolicy'}">Privacy Policy</router-link>
          </p>
        </v-flex>
        <v-flex xs12 sm4 class="white--text">
          <v-list class="transparent">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon class="primary--text text--lighten-2">phone</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="white--text">
                <v-list-tile-title>1.724.452.9366</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon class="primary--text text--lighten-2">email</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title><a class="white--text" href="mailto:sales@phototag.app">sales@phototag.app</a></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon class="primary--text text--lighten-2">place</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="white--text">
                330 Perry Hwy, Suite 200<br> Harmony, PA 16037
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex xs12 sm4 class="white--text">
          <div class="">
            <a target="_blank" href='https://play.google.com/store/apps/details?id=com.sdgsystems.collector.photos&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
              <img 
              style="width: 200px;"
              alt='Get it on Google Play'
              src='static/playstore.png'/>
            </a>
          </div>
          <div>
            <a target="_blank" href="https://apps.apple.com/us/app/phototag-sdg-systems/id1489381344?mt=8">
            <img
            style="width: 186px; padding-left: 12px;"
            alt="Get in in the iTunes Store"
            src="static/itunes.svg"/>
            </a>
          </div>
          <p class="ml-2">© 2020 SDG Systems - v{{ version }}</p>
        </v-flex>
      </v-layout>
      </v-container>
    </v-footer>

  </v-app>
</template>

<script>
import { version } from '../../package.json'

export default {
  data () {
    return {
      showDrawer: true,
      version: version
    }
  },

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Index.vue